import React, { useEffect, useContext, useState } from "react";
import { useHistory } from "react-router";
import { PortalContext } from "../../context/Provider";
import { hideModal, showModal } from "../../context/Actions/modal/modal";
import {
  logoutLaboTurnos,
  wsGetLaboTurnos,
  wsGetVerificarLaboGrupo,
} from "../../context/Actions/turnos/laboTurnos";
import {
  editaTurnosDisponibles,
  finalizaTurnosDisponibles,
  resetFiltrosDisponibles,
  setFechaTurno,
} from "../../context/Actions/turnos/turnosDisponibles";
import { showToaster } from "../../../global/context/action/toaster/toaster";
import { getDiaString } from "../../../global/utils/getDiaString";
import { getHoraString } from "../../../global/utils/getHoraString";

import Modal from "../../components/Genericos/Modal/Modal";
import ToasterV2 from "../../../global/component/Genericos/Toaster/ToasterV2";
import camelize from "../../../global/utils/camelize";
import InformacionIcon from "../../assets/images/generico/InformacionIcon";
import TurnosDisponiblesTxt from "./TurnosDisponiblesTxt";
import "./TurnosDisponiblesPcr.css";
import { displayAyuda, displayAyudaMobile } from "../../../global/utils/ayuda";
import { hideAyuda } from "../../context/Actions/ayuda/ayuda";
import { portalExteriorReset } from "../../context/Actions/paciente/portalPaciente";
import CardTurnoFiltroPcr from "../../components/PortalPCR/CardTurnoFiltroPcr/CardTurnoFiltroPcr";
import {
  altaProtocoloPcrReset,
  wsPostAltaProtocoloPcr,
} from "../../context/Actions/altaProtocoloPcr/altaProtocoloPcr";
import {
  limpiarDatosMedico,
  resetIdTurnoSolicitud,
  wsGetTurnosPaciente,
} from "../../context/Actions/turnos/turnosPaciente";
import Loading from "../../components/Genericos/Loading/Loading";
import HeaderBarFiltrosPcr from "../../components/PortalPCR/HeaderBarFiltrosPcr/HeaderBarFiltrosPcr";
import { mercadoPagoReset } from "../../context/Actions/mercadoPago/mercadoPago";
import BotonSubir from "../../assets/images/generico/BotonSubir";
import CardInformativoPcr from "../../components/PortalPCR/CardInformativo/CardInformativoPcr";
import { GlobalContext } from "../../../global/context/Provider";
import { parseFiltros } from "../../../global/utils/parseFilter";

const TurnosDisponiblesPcr = () => {
  const {
    modalState,
    modalDispatch,
    turnosDisponiblesState,
    turnosDisponiblesDispatch,
    laboTurnosState,
    laboTurnosDispatch,
    ayudaDispatch,
    portalExteriorDispatch,
    altaProtocoloPcrState,
    altaProtocoloPcrDispatch,
    turnosPacienteDispatch,
    turnosPacienteState,
    mercadoPagoDispatch,
    selectDropDownState,
    mercadoPagoState,
  } = useContext(PortalContext);

  const { toasterDispatch, toasterState, configState } =
    useContext(GlobalContext);

  const [dtoNuevaBusqueda, setDtoNuevaBusqueda] = useState();
  const [flgNuevaBusqueda, setFlgNuevaBusqueda] = useState(false);
  const [flgActualizarTurnos, setFlgActualizarTurnos] = useState(false);
  const [fechaBusqueda, setFechaBusqueda] = useState();
  const [turnosOriginal, setTurnosOriginal] = useState();
  const [flgRefreshFilter, setRefreshFilter] = useState(false);
  const [onChangeDate, setOnChangeDate] = useState("");
  const [confimoTurno, setConfirmoTurno] = useState(false);
  const [flgParticular, setFlgParticular] = useState(null);
  const [OSAlternativa, setOSAlternativa] = useState(false);
  const [dtoTurnoSeleccionado, setDtoTurnoSeleccionado] = useState(null);
  const [dtoAltaProtocoloPcr, setDtoAltaProtocoloPcr] = useState({
    id: null,
    idGrupoEstAlta: 3,
    IdGrupoEstudio: 3,
    esParticular: null,
    sectorTurno: "64",
  });
  const widthWindow = window.innerWidth;
  const history = useHistory();
  const fechaAux = new Date();

  const handleClickVolver = () => {
    logoutLaboTurnos()(laboTurnosDispatch);
    resetFiltrosDisponibles()(turnosDisponiblesDispatch);
    altaProtocoloPcrReset()(altaProtocoloPcrDispatch);
    portalExteriorReset()(portalExteriorDispatch);
    finalizaTurnosDisponibles()(turnosDisponiblesDispatch);
    if (configState.config.data.opcBuscadorTurnos && widthWindow > 1024) {
      history.push("/buscadorTurnos");
    } else {
      history.push("/loginpcr");
    }
  };

  const dissmiss = (origen) => {
    hideModal()(modalDispatch);
    if (
      origen === "mercadoPago" &&
      altaProtocoloPcrState.altaProtocoloPcr.data === 200
    ) {
      mercadoPagoReset()(mercadoPagoDispatch);
      showToaster(
        {
          texto: "Turno reservado correctamente",
          tipo: "success",
        },
        "centroArriba"
      )(toasterDispatch);
      handleClickVolver();
    } else if (origen === "osAlternativa") {
      setOSAlternativa(false);
    } else {
      setFlgParticular(null);
    }
  };

  const handleChangeDatePicker = (e) => {
    if (e !== null) {
      setOnChangeDate(e);
      setFechaTurno(e)(turnosDisponiblesDispatch);
    }
  };

  useEffect(() => {
    resetIdTurnoSolicitud()(turnosPacienteDispatch);
    limpiarDatosMedico()(turnosPacienteDispatch);
    //eslint-disable-next-line
  }, []);

  //cambio la fecha y escucho el cambio para enviarle la fecha correcta
  useEffect(() => {
    if (onChangeDate !== "") {
      onClickProximosTurnos();
      setOnChangeDate("");
    }
    //eslint-disable-next-line
  }, [onChangeDate]);

  const handleChangeCentros = (centroArrx) => {
    let origenLabo =
      turnosDisponiblesState.turnosDisponibles.turnosData.volverOrigen ===
      "LABORATORIO";
    if (origenLabo) {
      editaTurnosDisponibles({
        ...turnosDisponiblesState.turnosDisponibles.turnosData,
        filtrosData: {
          ...turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData,
          centrosLabo: centroArrx,
        },
      })(turnosDisponiblesDispatch);
    } else {
      editaTurnosDisponibles({
        ...turnosDisponiblesState.turnosDisponibles.turnosData,
        filtrosData: {
          ...turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData,
          centros: centroArrx,
        },
      })(turnosDisponiblesDispatch);
    }
  };

  //este useEffect filtra cuando se desmarco algun item del filtro.
  useEffect(() => {
    if (turnosOriginal !== undefined) {
      filtrarTurnos();
    }
    //eslint-disable-next-line
  }, [turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData]);

  //este useEffect vuelve a hacer el filtrado cuando traigo nuevos turnos.
  useEffect(() => {
    if (flgRefreshFilter) {
      setRefreshFilter(false);
      filtrarTurnos();
    }
    //eslint-disable-next-line
  }, [flgRefreshFilter]);

  const filtrarTurnos = () => {
    // defino una lista aux para filtrar siempre por el mismo resultado.
    if (turnosOriginal !== undefined) {
      // ------------------ ZONA EN LA QUE SE FITRAN LOS CENTROS ------------------------
      let auxCentro = null;
      if (
        turnosDisponiblesState.turnosDisponibles.turnosData.volverOrigen ===
        "LABORATORIO"
      ) {
        let centrosLabo =
          turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
            .centrosLabo;

        auxCentro =
          centrosLabo[0].checked === true
            ? centrosLabo
            : centrosLabo.filter(
                (centro) => centro.checked !== false && centro.id !== 0
              );
      } else {
        let centros =
          turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
            .centros;

        auxCentro =
          centros[0].checked === true
            ? centros
            : centros.filter(
                (centro) => centro.checked !== false && centro.id !== 0
              );
      }

      // // ------------------ ZONA EN LA QUE SE FITRAN LOS ESPECIALISTAS ------------------------
      // let especialistas =turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData.especialistas;
      // let auxEsp =
      //   especialistas[0].checked === true ? especialistas:
      //   especialistas.filter((especialista) => especialista.checked !== false && especialista.id !== 0);

      // ------------------ LA ZONA EN LA QUE SE FITRAN LOS DIAS ------------------------
      let dias =
        turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData.diasKin;
      let auxDiaSem =
        dias[0].checked === true
          ? dias
          : dias.filter((dia) => dia.checked !== false && dia.id !== 0);

      // ------------------ LA ZONA EN LA QUE SE FITRAN LOS RANGOS ------------------------
      let rangos =
        turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
          .rangoHorario;

      let auxRango =
        rangos[0].checked === true
          ? rangos
          : rangos.filter((rango) => rango.checked !== false && rango.id !== 0);

      // ------------------ LA ZONA EN LA QUE SE FITRAN QUE SE DEJAN LAS DESC EN EL ARRAY ------------------------
      auxCentro = auxCentro.map((array) => array.descripcion);
      // auxEsp = auxEsp.map((array) => array.descripcion);
      auxDiaSem = auxDiaSem.map((array) => array.descripcion);

      let turnoFiltrado = null;
      let turnoFiltradoAux1 = turnosOriginal.filter(
        (item) =>
          // auxCentro.includes(item.centro) &&
          auxCentro.includes(item.centro) &&
          // auxEsp.includes(
          // item.medico !== null
          // ? camelize(item.medico)
          // : camelize(item.recepcion)
          // ) &&
          auxDiaSem.includes(getDiaString(item.fecha))
      );

      if (auxRango.length > 0) {
        for (let i = 0; i < auxRango.length; i++) {
          let turnoFiltradoAux2 = turnoFiltradoAux1.filter(
            (item) =>
              getHoraString(item.hora) >= auxRango[i].horaMin &&
              getHoraString(item.hora) < auxRango[i].horaMax
          );
          if (i === 0) {
            turnoFiltrado = turnoFiltradoAux2;
          } else {
            turnoFiltrado = turnoFiltrado.concat(turnoFiltradoAux2);
          }
        }
      } else {
        turnoFiltrado = [];
      }

      turnoFiltrado = turnoFiltrado.sort((a, b) => {
        // Turn your strings into dates, and then subtract them
        // to get a value that is either negative, positive, or zero.
        return new Date(a.fecha) - new Date(b.fecha);
      });

      editaTurnosDisponibles({
        ...turnosDisponiblesState.turnosDisponibles.turnosData,
        turnos: turnoFiltrado,
      })(turnosDisponiblesDispatch);
    }
  };

  const handleChangeDia = (diaSemArrx) => {
    editaTurnosDisponibles({
      ...turnosDisponiblesState.turnosDisponibles.turnosData,
      filtrosData: {
        ...turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData,
        diasKin: diaSemArrx,
      },
    })(turnosDisponiblesDispatch);
  };

  const handleChangeRango = (rangoArrx) => {
    editaTurnosDisponibles({
      ...turnosDisponiblesState.turnosDisponibles.turnosData,
      filtrosData: {
        ...turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData,
        rangoHorario: rangoArrx,
      },
    })(turnosDisponiblesDispatch);
  };

  const handleChangeEspecialista = (espArrx) => {
    editaTurnosDisponibles({
      ...turnosDisponiblesState.turnosDisponibles.turnosData,
      filtrosData: {
        ...turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData,
        especialistas: espArrx,
      },
    })(turnosDisponiblesDispatch);
  };

  const handleOnClickConfirmar = (turnoSeleccionado) => {
    // idGrupoLaboratorio = 3 hace referencia a pcr
    const idGrupoLaboratorio = 3;
    if (flgParticular === null) {
      if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
        wsGetVerificarLaboGrupo(
          idGrupoLaboratorio,
          selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.id
        )(laboTurnosDispatch);
      } else {
        wsGetVerificarLaboGrupo(idGrupoLaboratorio)(laboTurnosDispatch);
      }
      if (laboTurnosState.laboTurnos.data !== null) {
        setDtoTurnoSeleccionado(turnoSeleccionado);
        setDtoAltaProtocoloPcr({
          id: turnoSeleccionado.idturno,
          IdGrupoEstAlta: idGrupoLaboratorio,
          IdGrupoEstudio: idGrupoLaboratorio,
          esParticular: flgParticular,
        });
      }
    } else {
      wsPostAltaProtocoloPcr(dtoAltaProtocoloPcr)(altaProtocoloPcrDispatch);
      // setConfirmoTurno(true);
    }
  };

  useEffect(() => {
    if (
      altaProtocoloPcrState.altaProtocoloPcr.data !== null &&
      altaProtocoloPcrState.altaProtocoloPcr.data === 200
    ) {
      wsGetTurnosPaciente()(turnosPacienteDispatch);
    }
    //eslint-disable-next-line
  }, [altaProtocoloPcrState.altaProtocoloPcr.data]);

  //hacer filter y traer el turno seleccionado

  useEffect(() => {
    if (turnosPacienteState.turnosPaciente.data !== null) {
      const turnoSeleccionado = turnosPacienteState.turnosPaciente.data.filter(
        (item) => item.idturno === dtoAltaProtocoloPcr.id
      );
      if (turnoSeleccionado.length > 0) showModalAbonar(turnoSeleccionado);
    }
    //eslint-disable-next-line
  }, [turnosPacienteState.turnosPaciente.data]);

  const showModalAbonar = (item) => {
    showModal(
      "Turnos/AbonaTurno/AbonaTurno",
      {
        idturno: item[0].idturno,
        idProtocolo: item[0].idProtocolo,
        monto: item[0].monto,
        fecha: item[0].fecha,
        hora: item[0].hora,
        centro: item[0].centro,
        especialidad: item[0].especialidad,
        origen: "loginpcr",
        dismiss: () => dissmiss("mercadoPago"),
      },
      {},
      "centro",
      true
    )(modalDispatch);
  };

  useEffect(() => {
    if (flgParticular !== null) {
      setDtoAltaProtocoloPcr({
        ...dtoAltaProtocoloPcr,
        esParticular: flgParticular,
      });
      if (flgParticular) {
        modalParticular();
      }
    }
    //eslint-disable-next-line
  }, [flgParticular]);

  useEffect(() => {
    if (OSAlternativa !== null) {
      setDtoAltaProtocoloPcr({
        ...dtoAltaProtocoloPcr,
        OsAlternativa: OSAlternativa,
      });
      if (flgParticular) {
        modalOSAlternativa();
      }
    }
    //eslint-disable-next-line
  }, [OSAlternativa]);

  useEffect(() => {
    if (confimoTurno) {
      if (
        laboTurnosState.laboTurnos.data !== null &&
        laboTurnosState.laboTurnos.data !== undefined &&
        laboTurnosState.laboTurnos.data.hora > 1
      ) {
        logoutLaboTurnos()(laboTurnosDispatch);
        resetFiltrosDisponibles()(turnosDisponiblesDispatch);
        setConfirmoTurno(false);
      } else if (
        laboTurnosState.laboTurnos.error !== false &&
        laboTurnosState.laboTurnos.error !== null
      ) {
        if (laboTurnosState.laboTurnos.error.detail !== "9") {
          showToaster(
            {
              texto: "Error al tomar el turno",
              tipo: "danger",
            },
            "centroArriba"
          )(toasterDispatch);
        }
      }
    }
    //eslint-disable-next-line
  }, [laboTurnosState]);

  const onClickFiltrosMobile = () => {
    showModal(
      "PortalPCR/FiltrosTurnosPcr/FiltrosTurnosPcr",
      {
        titulo: "Filtrar turnos",
        dissmiss: dissmiss,
        handleClickBuscar: dissmiss,
        handleClickProximos: onClickProximosTurnos,
        handleChangeDatePicker: handleChangeDatePicker,
        fecha: fechaAux,
      },
      [],
      "centro"
    )(modalDispatch);
  };

  //HAY QUE MEJORAR Y PREPARAR LA LOGICA PARA TODAS LAS BUSQUEDAS DESDE ACA.

  const onClickProximosTurnos = () => {
    dissmiss();
    let fechaSliced =
      turnosDisponiblesState.turnosDisponibles.turnosData.fechaBusqueda.slice(
        0,
        -9
      );
    if (onChangeDate !== "") {
      fechaSliced = onChangeDate;
    }

    setFlgNuevaBusqueda(true);
    if (laboTurnosState.laboTurnos.data !== null) {
      setDtoNuevaBusqueda({
        ...dtoNuevaBusqueda,
        fechaDesde: fechaSliced,
      });
      setFechaBusqueda(fechaSliced);
    }
    //lo limpio para que cuando use esta funcion sin el filtro fecha, obtenga le fecha deseada.
    setOnChangeDate("");
  };

  const modalParticular = () => {
    showModal(
      "PortalPCR/ModalParticularPcr/ModalParticularPcr",
      {
        titulo: "La obra social no cubre el estudio",
        textoNegrita: "¿Desea tomar el turno como particular?",
        texto: "El estudio seleccionado no figura dentro de tu cobertura",
        dto: dtoTurnoSeleccionado,
        dissmiss: dissmiss,
        onClickAceptar: tomarTurnoParticular,
        onClickCancelar: dissmiss,
      },
      [],
      "centro",
      true
    )(modalDispatch);
  };

  const modalOSAlternativa = () => {
    showModal(
      "PortalPCR/ModalParticularPcr/ModalParticularPcr",
      {
        titulo: "La obra social no cubre el estudio",
        textoNegrita: "¿Deseás tomar el turno con tu obra social alternativa?",
        texto: "La determinacion seleccionada no figura dentro de tu cobertura",
        dto: dtoTurnoSeleccionado,
        dissmiss: () => dissmiss("osAlternativa"),
        onClickAceptar: tomarTurnoParticular,
        onClickCancelar: () => dissmiss("osAlternativa"),
      },
      [],
      "centro",
      true
    )(modalDispatch);
  };

  const tomarTurnoParticular = () => {
    setConfirmoTurno(true);
  };

  useEffect(() => {
    if (dtoAltaProtocoloPcr.esParticular !== null && confimoTurno) {
      dissmiss();
      wsPostAltaProtocoloPcr(dtoAltaProtocoloPcr)(altaProtocoloPcrDispatch);
    }
    //eslint-disable-next-line
  }, [dtoAltaProtocoloPcr.esParticular, confimoTurno]);

  useEffect(() => {
    if (flgNuevaBusqueda) {
      if (laboTurnosState.laboTurnos.data !== null) {
        wsGetLaboTurnos(
          fechaBusqueda,
          -1,
          -1,
          3
          // dtoNuevaBusqueda.idGrupo
        )(laboTurnosDispatch);
        setFlgActualizarTurnos(true);
      }
    }
    //eslint-disable-next-line
  }, [dtoNuevaBusqueda]);

  useEffect(() => {
    if (
      laboTurnosState.laboTurnos.error !== null &&
      laboTurnosState.laboTurnos.error !== undefined &&
      laboTurnosState.laboTurnos.error !== false
    ) {
      if (laboTurnosState.laboTurnos.error.detail === "9") {
        setFlgParticular(true);
      } else if (laboTurnosState.laboTurnos.error.detail === "91") {
        setOSAlternativa(true);
      } else {
        if (
          laboTurnosState.laboTurnos.error.detail !== "" &&
          laboTurnosState.laboTurnos.error.detail !== null &&
          laboTurnosState.laboTurnos.error.detail !== undefined
        ) {
          showToaster(
            {
              texto: laboTurnosState.laboTurnosState.error.detail,
              tipo: "danger",
            },
            "centroArriba"
          )(toasterDispatch);

          // logoutEstudiosTurnos()(estudioTurnosDispatch);
        } else {
          showToaster(
            {
              texto: laboTurnosState.laboTurnosState.error,
              tipo: "danger",
            },
            "centroArriba"
          )(toasterDispatch);
          // logoutEstudiosTurnos()(estudioTurnosDispatch);
        }
      }
    }
    //eslint-disable-next-line
  }, [laboTurnosState]);

  useEffect(() => {
    if (flgActualizarTurnos) {
      editaTurnosDisponibles({
        ...turnosDisponiblesState.turnosDisponibles.turnosData,
        turnos: laboTurnosState.laboTurnos.data?.data,
        fechaBusqueda: laboTurnosState.laboTurnos.data.fechaBusqueda,
        dtoBusqueda: dtoNuevaBusqueda,
      })(turnosDisponiblesDispatch);
      setTurnosOriginal(laboTurnosState.laboTurnos.data?.data);
      setRefreshFilter(true);
    }
    //eslint-disable-next-line
  }, [laboTurnosState]);

  useEffect(() => {
    if (turnosDisponiblesState.turnosDisponibles.turnosData.turnos === null) {
      handleClickVolver();
    } else {
      setTurnosOriginal(
        turnosDisponiblesState.turnosDisponibles.turnosData.turnos
      );
      setDtoNuevaBusqueda(
        turnosDisponiblesState.turnosDisponibles.turnosData.dtoBusqueda
      );
      hideAyuda()(ayudaDispatch);
      displayAyuda("hidden");
      displayAyudaMobile("hidden");
    }
    //eslint-disable-next-line
  }, []);

  return (
    <React.Fragment>
      {modalState.modal.show && <Modal />}
      {toasterState.toaster.show && <ToasterV2 />}
      <HeaderBarFiltrosPcr
        handleClickVolver={handleClickVolver}
        handleChangeDatePicker={handleChangeDatePicker}
        handleChangeCentros={handleChangeCentros}
        handleChangeDia={handleChangeDia}
        handleChangeRango={handleChangeRango}
        handleChangeEspecialista={handleChangeEspecialista}
        turnosData={turnosDisponiblesState.turnosDisponibles.turnosData.turnos}
        filtrosData={
          turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
        }
        fecha={fechaAux}
      />
      {/* ||
              (mercadoPagoState.mercadoPago.loading && "Generando pago...") */}
      <Loading
        dataLoading={
          altaProtocoloPcrState.altaProtocoloPcr.loading ||
          turnosPacienteState.turnosPaciente.loading ||
          laboTurnosState.laboTurnos.loading ||
          mercadoPagoState.mercadoPago.loading
        }
        color="c-white"
        descripcion={
          ((laboTurnosState.laboTurnos.loading ||
            turnosPacienteState.turnosPaciente.loading) &&
            "Cargando...") ||
          (altaProtocoloPcrState.altaProtocoloPcr.loading &&
            "Confirmando turno...") ||
          (mercadoPagoState.mercadoPago.loading && "Generando pago...")
        }
      />
      <div className="ptur-turnosDisponiblesPcr-headerTurno">
        <div className="ptur-turnosDisponiblesPcr-filtrosMobile-container">
          <button
            onClick={onClickFiltrosMobile}
            className="ptur-turnosDisponiblesPcr-filtrosMobile-btn c-latex30 rb18mh"
          >
            Filtros
          </button>
        </div>
        <div className="ptur-turnosDisponiblesPcr-proxTurnosBar">
          <button
            onClick={onClickProximosTurnos}
            className="ptur-turnosDisponiblesPcr-proxTurnosBtn c-latex30 bgc-transparent"
          >
            Buscar más turnos
          </button>
        </div>
      </div>
      <div className="ptur-turnosDisponiblesPcr-bodyContainer">
        {laboTurnosState.laboTurnos.loading ? (
          ""
        ) : (
          <div className="ptur-turnosDisponiblesPcr-bodyContainer-boxSinturno">
            {laboTurnosState.laboTurnos.data?.data &&
              laboTurnosState.laboTurnos.data?.data.length <= 0 && (
                <div className="ptur-turnosDisponiblesPcr-noEcontrados-container">
                  <div className="ptur-turnosDisponiblesPcr-noEcontrados-icono">
                    <InformacionIcon />
                  </div>
                  <div className="ptur-turnosDisponiblesPcr-noEcontrados-texto">
                    <TurnosDisponiblesTxt
                      fecha={new Date(
                        turnosDisponiblesState.turnosDisponibles.turnosData
                          .fechaBusqueda,
                      ).toLocaleDateString("es-AR", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "2-digit",
                      })}
                    />
                  </div>
                  <div className="ptur-turnosDisponiblesPcr-noEcontrados-contenedorBoton">
                    <button
                      className="ptur-turnosDisponiblesPcr-noEcontrados-boton rb18m"
                      onClick={onClickProximosTurnos}
                    >
                      Proximos turnos disponibles
                    </button>
                  </div>
                </div>
              )}
          </div>
        )}

        <div className="boxTurnos-body">
          {laboTurnosState.laboTurnos.data &&
            !laboTurnosState.laboTurnos.loading && <CardInformativoPcr />}
          {laboTurnosState.laboTurnos.data &&
            !laboTurnosState.laboTurnos.loading &&
            turnosDisponiblesState.turnosDisponibles.turnosData.turnos?.map(
              (item, index) => {
                return (
                  <React.Fragment key={index}>
                    <CardTurnoFiltroPcr
                      handleOnClickConfirmar={() =>
                        handleOnClickConfirmar(item)
                      }
                      idTurno={item.idturno}
                      medico={camelize(item.medico !== null ? item.medico : "")}
                      centro={item.centro}
                      ubicacion={item.ubicacion}
                      hora={item.hora}
                      fecha={item.fecha}
                      especialidad={
                        item.especialidad !== null
                          ? camelize(item.especialidad)
                          : ""
                      }
                    />
                  </React.Fragment>
                );
              }
            )}
        </div>
        {laboTurnosState.laboTurnos.loading ? (
          ""
        ) : (
          <div className="ptur-turnosDisponiblesPcr-botonSubir">
            <BotonSubir body={"ptur-turnosDisponiblesPcr-bodyContainer"} />
          </div>
        )}
        <div className="footerHelp"></div>
      </div>
    </React.Fragment>
  );
};

export default TurnosDisponiblesPcr;
